import React from 'react';
import { ChevronUp, ChevronDown } from 'react-feather';
import PropTypes from 'prop-types';
import { classNames } from '../../functions/classNames';
import getLabel from '../../translations/messages';
import './Table.css';

export const Column = props => {
  const childs = React.Children.map(props.children,
    child => React.cloneElement(child, {
      resource: props.data,
      handleRemove: props.handleRemove,
      handleAdd: props.handleAdd,
      handleResend: props.handleResend,
      updateResults: props.updateResults,
      toggleModal: props.toggleModal,
      ...child.props,
    })
  );

  return <td>{childs}</td>;
};

const ContentRow = props => {
  const row = React.Children.map(props.children,
    child => React.cloneElement(child, {
      data: props.data,
      handleRemove: props.handleRemove,
      handleAdd: props.handleAdd,
      handleResend: props.handleResend,
      updateResults: props.updateResults,
      toggleModal: props.toggleModal,
      name: props.name,
      ...child.props,
    })
  );

  return <tr>{row}</tr>;
};

const changeOrdering = (name, ordering, asc, handleFilterChange) => {
  if (ordering === name) {
    handleFilterChange({ target: { name: 'asc', value: asc === 'true' ? 'false' : 'true' } });
  } else {
    handleFilterChange({ target: { name: 'order', value: name } });
  }
};

const OrderingIcon = props => (
  <span>
    {props.asc === 'false' ? <ChevronDown size={18} /> : <ChevronUp size={18} />}
  </span>
);

const renderHeader = (context, props, {order, asc}, handleFilterChange) => {
  const {locale, config} = context;
  const {label, orderingName, configKey} = props;

  if (configKey && config[configKey] !== true) {
    return null;
  }

  return orderingName ?
    <th className="orderable"
        onClick={() => changeOrdering(orderingName, order, asc, handleFilterChange)}>
      {getLabel(locale, label)}
      {(order === orderingName) ? <OrderingIcon asc={asc}/> : ''}
    </th> :
    <th>{getLabel(locale, label)}</th>
}

const Table = (props, context) => {
  const { data, children, filters, handleFilterChange } = props;

  const header = React.Children.map(children,
      (child, i) => renderHeader(context,
                                child.props,
                                filters,
                                handleFilterChange)
  );

  const empty = data.length <= 0;

  return (
    <table className={classNames('Table', (empty ? 'table-empty' : 'table-results'))}>
      <thead>
        <tr>{header}</tr>
      </thead>
      <tbody>
        {empty ? <tr><td colSpan={children.length}>Nessun Risultato</td></tr> :
          data.map((d, i) =>
            <ContentRow {...props} key={i} data={d} />
          )
        }
      </tbody>
    </table>
  );
};

Table.contextTypes = {
  locale: PropTypes.string,
  config: PropTypes.object,
};

export default Table;



// WEBPACK FOOTER //
// ./src/main/components/container/Table.js